<template>
    <div>
        <v-card  class="pa-0">
            <v-card-title class="font-weight-bold py-1">
                <v-icon left color="primary" class="mr-1" style="font-size:18px;">mdi-poll</v-icon>
                <span style="font-size:15px;">Active Polls</span>
            </v-card-title>
            <v-divider class="my-0"></v-divider>
            <v-card-text class="pa-0" style="overflow-y:auto; max-height:120px;">
                <v-skeleton-loader v-if="loading" type="list-item-three-line" class="py-1"></v-skeleton-loader>
                <div v-else-if="polls.length === 0" class="text-center grey--text py-2">
                    No active polls available.
                </div>
                <v-card 
                    v-for="poll in polls" :key="poll.id" 
                    class="ma-2 grey lighten-4" flat style="cursor:pointer;"
                    @click="poll.type == 'live' ? $router.push({ name: 'PollView', params: { uuid: poll.uuid } }) : poll.type == 'result' ? $refs.pollResultsModal.open(poll.id) : null"
                >
                    <!-- @click="$router.push({ name: 'PollView', params: { uuid: poll.uuid } })" -->
                    <div class="d-flex justify-space-between items-center align-center ml-3">
                        <div>
                            <div class="font-weight-medium" style="font-size:20px;">
                                {{ poll.title }}
                            </div>
                            <div v-if="poll.type == 'live'" class="text-truncate grey--text text--darken-1" style="font-size:12px;">
                                Ends At: {{$localeDateTime(poll.end_time)}}
                            </div>
                            <div v-if="poll.type == 'result'" class="text-truncate grey--text text--darken-1" style="font-size:12px;">
                                View results
                            </div>
                            <div v-if="poll.type == 'upcoming'" class="text-truncate grey--text text--darken-1" style="font-size:12px;">
                                Starts At: {{$localeDateTime(poll.start_time)}}
                            </div>
                        </div>
                        <div class="d-flex align-center">
                            <PercentChart
                                style="width: 100px;"
                                class="mt-2"
                                title="Voted"
                                height="80"
                                :percent="poll.counts.percent_voted"
                                mainColor="#0B83F4"
                                accentColor="#BBDCFC"
                                :percent_label_size="'12px'"
                            />
                        </div>
                    </div>
                </v-card>
            </v-card-text>
        </v-card>

        <PollResultsModal ref="pollResultsModal" />
    </div>
</template>

<script>
import PercentChart from '../charts/am5PercentChart.vue';
import axios from '../../plugins/axios';
import PollResultsModal from './PollResultsModal.vue';

export default {
    components: {PercentChart, PollResultsModal},
    data() {
        return {
            loading: false,
            polls: []
        };
    },
    methods: {
        getActivePolls() {
            this.loading = true
            axios.get(`/api/polls/active-polls`).then((resp) => {
                this.polls = resp.data
            }).finally(() => this.loading = false)
        }
    },
    mounted() {
        this.getActivePolls()
    },
}
</script>

<style>

</style>